<template>
    <div class="years-input">
        <div class="years-input-padding">
            <input
                ref="input"
                v-bind:value="value"
                v-bind:disabled="disabled"
                v-on:input="updateValue($event.target.value)"
                v-on:focus="selectAll"
                v-on:blur="formatValue" />
        </div>
        <label>Yrs.</label>
    </div>
</template>

<style lang="scss">
    .years-input {
        position: relative;
		font-size: 0.8em;
        border: 1px solid #ccc;
        padding: 2px;
        background: #fff;
        .years-input-padding {
            padding-right: 1.5em;
        }
        label {
            font-size: 0.8em;
            font-weight: 300;
            display: block;
            position: absolute;
            top: 0.4em;
            right: 0.4em;
            opacity: 1;
            color: #333333;
            max-width: none;
            margin: 0;
        }
        input {
            border: 0;
            padding: 0;
            width: 1.5em;
            background: #fff;
            text-align: right;
        }
    }
</style>

<script>
    export default {
        props: {
			value:{
				type: [String,Number],
				default: ''
			},
			disabled: {
				type: Boolean,
				default: false,
            },            
		},

        mounted() {
            this.formatValue();
        },

        methods: {
            updateValue(value) {
                var parseValue = (value + '').replace(/[^0-9]/g, '');
                this.$refs.input.value = parseValue;
                this.$emit('input', parseValue);
            },
            formatValue() {
				let formattedValue = Math.floor(Number(this.$refs.input.value)) + '';
				this.$refs.input.value = formattedValue;
				this.$emit('input', formattedValue);
            },
            selectAll(event) {
                // Workaround for Safari bug
                // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
                setTimeout(function () {
                    event.target.select()
                }, 0)
			},
        }
    }
</script>